import { restClient } from '../../client';

export type AppointmentCountResponse = {
  data: {
    [id: string]: string[];
  };
};

export const getAppointmentCounts = async () => {
  const response = await restClient.request('/api/v1/appointment/get_appointment_counts');
  const typedResponse = response as unknown as AppointmentCountResponse;

  return typedResponse.data;
};
